export const AUTH_TOKEN = 'auth_token';
export const REFRESH_TOKEN = 'refresh_token';
export const USER_INFO = 'user_info';
export const TOKEN_EXPIRY = 'token_expiry';
